module.exports = __webpack_public_path__ + "img/spain.83c2c6d8.jpg";